import request from '@/utils/request'
import exportExcel from '@/utils/export'
export function getUser(params) {
  return request({
    url:'/admin/member/page',
    method:'get',
    params:params
  })
}
export function getUserExport(params) {
  return exportExcel({
    url:'/admin/member/page-export',
    method:'get',
    params: params
  }, "会员列表")
}
//获取会员登录IP地址列表
export function getIPList(params) {
  return request({
    url: '/admin/member/loginLog/list',
    method: 'get',
    params:params
  })
}
//获取代理列表
export function getProxyList(params) {
  return request({
    url: '/admin/member/agentForSearch',
    method: 'get',
    params:params
  })
}
// 获取直属上级列表
export function getSuperiorList(params) {
  return request({
    url: '/admin/member/member-excludeSubordinate',
    method: 'get',
    params: params
  })
}
/**
 * 获取用户上级
 * @param {Object} memberId
 */
export function getParentMemberList(memberId){
  return request({
    url: '/admin/member/getParentMemberList?memberId='+memberId,
    method: 'get'
  })
}
//获取代理列表-真实姓名
export function getProxyListByRealName(params) {
  return request({
    url: '/admin/member/agentForSearch-byRealName',
    method: 'get',
    params:params
  })
}
//修改会员的冻结状态
export function isFrozen(params) {
  return request({
    url:'/admin/member/update/isFrozen',
    method:'put',
    params:params
  })
}
//获取会员详情-主页
export function getHomePage(params) {
  return request({
    url:'/admin/memberDetail/homePage',
    method:'get',
    params:params
  })
}
//获取会员详情-佣金
export function getRebate(params) {
  return request({
    url:'/admin/memberDetail/rebate',
    method:'get',
    params:params
  })
}
//获取会员详情-跟单管理
export function getFollowup(params) {
  return request({
    url:'/admin/memberDetail/followUp',
    method:'get',
    params:params
  })
}
//获取会员详情-推广链接
export function getPromote(params) {
  return request({
    url:'/admin/memberDetail/spreadLink',
    method:'get',
    params:params
  })
}
//获取会员详情-交易信息
export function getTransaction(params) {
  return request({
    url:'/admin/memberDetail/exchangeOrderInformation',
    method:'get',
    params:params
  })
}
//获取会员详情-出入金管理
export function getInAndOutMoney(params) {
  return request({
    url:'/admin/memberDetail/inAndOutMoney',
    method:'get',
    params:params
  })
}
//获取历史交易信息
export function getHistory(params) {
  return request({
    url:'/admin/memberDetail/exchangeOrderHistory/list',
    method:'get',
    params:params
  })
}
//获取会员佣金记录
export function getRebateRecord(params) {
  return request({
    url:'/admin/memberDetail/rebateBenefitRecord',
    method:'get',
    params:params
  })
}
//获取当前持仓信息
export function getCurrent(params) {
  return request({
    url:'/admin/memberDetail/exchangeOrderCurrent/list',
    method:'get',
    params:params
  })
}
//获取会员跟随的人员详情
export function getFollowerDetail(params) {
  return request({
    url:'/admin/memberDetail/followUp/memberList',
    method:'get',
    params:params
  })
}
//获取跟单记录
export function getFollowDetail(params) {
  return request({
    url:'/admin/memberDetail/followUp/detail',
    method:'get',
    params:params
  })
}
//获取下级团队
export function getDownTeam(params) {
  return request({
    url:'/admin/memberDetail/subordinate/detail',
    method:'get',
    params:params
  })
}
//后台手动添加用户
export function addUser(data) {
  return request({
    url:'/admin/member/create',
    method:'post',
    data:data
  })
}
//获取用户角色
export function getLeve(params) {
  return request({
    url:'/admin/level/list',
    method:'get',
    params:params
  })
}
//获取用户账号
export function getAccounts(params) {
  return request({
    url:'/admin/member/accounts/' + params.memberId,
    method:'get',
    params:params
  })
}
export function getRisk(memberId) {
  return request({
    url:'/admin/member/risk/' + memberId,
    method:'get'
  })
}
//增加用户余额
export function addBalance(data) {
  return request({
    url:'/admin/member/addBalance',
    method:'post',
    data
  })
}
//发送消息
export function sendMessage(data) {
  return request({
    url:'/admin/member/sendMessage',
    method:'post',
    data
  })
}
//修改用户可用状态
export function isAvailable(params) {
  return request({
    url:'/admin/member/status/'+params.memberId,
    method:'put',
  })
}
export function setUserTstatus(params) {
  return request({
    url:'/admin/member/tstatus/'+params.memberId,
    method:'put',
  })
}
//修改昵称
export function updataNickname(data) {
  return request({
    url:'/admin/member/member-info',
    method:'put',
    data:data
  })
}
export function resetUserPsw(data,type) {
  return request({
    url:'/admin/member/reset-password/' + data+"?type="+type,
    method:'put',
  })
}
//修改用户等级和直属上级
export function updataAmount(data) {
  return request({
    url:'/admin/member/memberLevel',
    method:'put',
    data: data
  })
}
export function updataInviter(data) {
  return request({
    url:'/admin/member/update/inviter',
    method:'put',
    data:data
  })
}
//修改会员信号源
export function updataSignal(data) {
  return request({
    url:'/admin/member/isSignal',
    method:'put',
    data:data
  })
}
//获取直属上级信息
export function getPhoneLike(params) {
  return request({
    url:'/admin/member/excludeSubordinate',
    method:'get',
    params:params
  })
}
//删除会员
export function deleteUser(data) {
  return request({
    url:'/admin/member/delete/' + data,
    method:'delete',
  })
}
//获取实名认证列表
export function getReal(params) {
  return request({
    url:'/admin/realNameVerified',
    method:'get',
    params:params
  })
}
//获取实名详情
export function getRealDetail(params) {
  return request({
    url:'/admin/realNameVerified/detail',
    method:'get',
    params:params
  })
}
//添加备注
export function addRemark(data) {
  return request({
    url:'/admin/realNameVerified/addRemark',
    method:'put',
    data:data
  })
}
//审核通过
export function passReview(data) {
  return request({
    url:'/admin/realNameVerified/pass/'+data.id ,
    method:'put',
  })
}
//审核驳回
export function failReview(data) {
  return request({
    url:'/admin/realNameVerified/fail',
    method:'put',
    data:data
  })
}
//获取会员回答的结果
export function getSurveyDetail(params) {
  return request({
    url:'/admin/questionResult/getOne',
    method:'get',
    params:params
  })
}
// 获取邀请记录列表
export function getInviteRecordList(params) {
  return request({
    url:'/admin/invite-record/list',
    method:'get',
    params:params
  })
}
//
export function getUserAssetsRecord(params) {
  return request({
    url: '/admin/memberDetail/list-myTransaction',
    method: 'get',
    params: params
  })
}
export function getMemberAssetStat(params) {
  return request({
    url: '/admin/transaction/queryMemberStat',
    method: 'get',
    params: params
  })
}
export function updateWithdrawal(params) {
  return request({
    url:'/admin/member/update/withdrawal',
    method:'put',
    params:params
  })
}

export function doSendEmail(params) {
  return request({
    url:'/common/sendMail',
    method:'post',
    params:params
  })
}
export function kickUser(params) {
  return request({
    url:'/admin/member/kickMember',
    method:'get',
    params:params
  })
}
export function queryRebatePage(params) {
  return request({
    url:'/admin/rebate/getRebatePage',
    method:'post',
    data:params
  })
}
export function updateRebateState(params) {
  return request({
    url:'/admin/rebate/updateState',
    method:'get',
    params:params
  })
}
export function updateBatchWithdrawal(params) {
  return request({
    url:'/admin/member/updateBatch/withdrawal',
    method:'put',
    params:params
  })
}
export function queryAllamount(params) {
  return request({
    url:'/admin/member/amount',
    method:'get',
    data:params
  })
}
export function sameDayInviter(params) {
  return request({
    url:'/admin/member/sameDayInviter',
    method:'get',
    data:params
  })
}

export function setMemberAdmin(params) {
  return request({
    url:'/admin/member/setAdmin',
    method:'get',
    params:params
  })
}
export function updateToChecking(params) {
  return request({
    url:'/admin/realNameVerified/updateToChecking',
    method:'get',
    params:params
  })
}
export function getDupIds() {
  return request({
    url:'/admin/realNameVerified/dupIds',
    method:'get'
  })
}
export function getFundStat() {
  return request({
    url:'/admin/deposit/getFundStat',
    method:'get'
  })
}
export function resetGcode(memberId) {
  return request({
    url:'/admin/member/update/resetGcode?memberId='+memberId,
    method:'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/user.js